export enum EProductType {
    DryLoad = "DryLoad",  // Carga seca
    Bulk = "Bulk",        // Granéis
    Other = "Other",      // Outros
}